/**
 * PWA service-worker registration via Workbox.
 *
 * Uses `registerType: "prompt"` so a waiting update never reloads mid-read; the
 * caller decides when to apply it. Registration is a no-op when the SW is
 * unsupported (older WebViews) so the app still runs online.
 */

import { registerSW } from "virtual:pwa-register";

export interface SwController {
  /** Apply a waiting update and reload. */
  update: () => void;
}

export function registerServiceWorker(
  onNeedRefresh: (controller: SwController) => void,
): void {
  if (!("serviceWorker" in navigator)) return;

  const update = registerSW({
    immediate: true,
    onNeedRefresh() {
      onNeedRefresh({ update: () => void update(true) });
    },
  });
}
